import React, { FC } from "react";
import { IconType } from "./types";

export const RedRepairIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      d="M10.4207 5.08758C10.1567 4.82357 10.0247 4.69157 9.97526 4.53935C9.93176 4.40545 9.93176 4.26122 9.97526 4.12732C10.0247 3.97511 10.1567 3.8431 10.4207 3.57909L12.313 1.68684C11.8108 1.45975 11.2534 1.33334 10.6665 1.33334C8.45735 1.33334 6.66649 3.1242 6.66649 5.33334C6.66649 5.6607 6.70582 5.97887 6.78 6.28339C6.85944 6.6095 6.89916 6.77255 6.89211 6.87556C6.88472 6.9834 6.86865 7.04077 6.81891 7.13675C6.77141 7.22842 6.6804 7.31943 6.49837 7.50146L2.33316 11.6667C1.78087 12.219 1.78087 13.1144 2.33316 13.6667C2.88544 14.219 3.78087 14.219 4.33316 13.6667L8.49837 9.50146C8.6804 9.31943 8.77141 9.22842 8.86308 9.18091C8.95906 9.13118 9.01643 9.1151 9.12427 9.10772C9.22728 9.10067 9.39033 9.14039 9.71643 9.21983C10.021 9.29401 10.3391 9.33334 10.6665 9.33334C12.8756 9.33334 14.6665 7.54247 14.6665 5.33334C14.6665 4.7464 14.5401 4.18898 14.313 3.68684L12.4207 5.57909C12.1567 5.8431 12.0247 5.97511 11.8725 6.02456C11.7386 6.06807 11.5944 6.06807 11.4605 6.02456C11.3083 5.97511 11.1763 5.8431 10.9122 5.57909L10.4207 5.08758Z"
      stroke="#F44336"
      strokeWidth="1.41667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
